import React from 'react';
import { prefersReducedMotion } from './profileUtils.js';

function SlotNumber({ value, delayMs }) {
    const reduce = prefersReducedMotion();
    const line = 28;
    const safeValue = Math.max(0, Number(value) || 0);
    const duration = 420 + safeValue * 70;

    if (reduce) {
        return (
            <span className="profile-slot profile-slot--static">{safeValue}</span>
        );
    }

    const ticks = [];
    for (let n = 0; n <= safeValue; n += 1) ticks.push(n);

    return (
        <span className="profile-slot">
            <span
                className="profile-slot-reel"
                style={{
                    animationDuration: `${duration}ms`,
                    animationDelay: `${delayMs}ms`,
                    ['--slot-end']: `-${safeValue * line}px`,
                }}
            >
                {ticks.map((n) => (
                    <span key={n} className="profile-slot-tick">{n}</span>
                ))}
            </span>
        </span>
    );
}

export default function GlanceStats({ watching, channels, platforms }) {
    return (
        <div className="profile-glance" aria-label="Account snapshot">
            <div className="profile-glance-item">
                <div className="profile-glance-value">
                    <SlotNumber value={watching} delayMs={0} />
                </div>
                <div className="profile-glance-label">
                    <span>Watching</span>
                </div>
            </div>
            <div className="profile-glance-item">
                <div className="profile-glance-value">
                    <SlotNumber value={channels} delayMs={90} />
                </div>
                <div className="profile-glance-label">
                    <span>Followed</span>
                    <span>Channels</span>
                </div>
            </div>
            <div className="profile-glance-item">
                <div className="profile-glance-value profile-glance-value--success">
                    <SlotNumber value={platforms} delayMs={180} />
                </div>
                <div className="profile-glance-label">
                    <span>Connected</span>
                    <span>Platforms</span>
                </div>
            </div>
        </div>
    );
}
